(() => {
  const initialise = (root) => {
    if (!root || root.dataset.pwGuideReady === 'true') return;

    root.dataset.pwGuideReady = 'true';

    const content = root.querySelector('.js-pw-guide-content');
    const toc = root.querySelector('.js-pw-guide-toc');
    const tocList = root.querySelector('.js-pw-guide-toc-list');

    if (!content) return;

    content.querySelectorAll('table').forEach((table) => {
      if (table.parentElement?.classList.contains('pw-guide-article__table-wrap')) return;

      const wrapper = document.createElement('div');
      wrapper.className = 'pw-guide-article__table-wrap';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });

    if (!toc || !tocList) return;

    const headings = [...content.querySelectorAll('h2, h3')].filter(
      (heading) => heading.textContent.trim().length > 0
    );

    if (headings.length < 2) return;

    const usedIds = new Set();

    const slugify = (value) => {
      const base = value
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || 'onderdeel';

      let slug = base;
      let index = 2;

      while (usedIds.has(slug) || document.getElementById(slug)) {
        slug = `${base}-${index}`;
        index += 1;
      }

      usedIds.add(slug);
      return slug;
    };

    const links = headings.map((heading) => {
      if (!heading.id) heading.id = slugify(heading.textContent.trim());

      const item = document.createElement('li');
      item.className = 'pw-guide-article__toc-item';

      if (heading.tagName === 'H3') {
        item.classList.add('pw-guide-article__toc-item--sub');
      }

      const title = heading.textContent.trim();
      const normalised = title.toLowerCase();

      const iconMap = [
        { terms: ['temperatuur', 'zone', 'warm', 'koud', 'koelen'], svg: '<svg viewBox="0 0 24 24" fill="none"><path d="M10 5a2 2 0 1 1 4 0v8.2a4 4 0 1 1-4 0V5Z" stroke="currentColor" stroke-width="1.6"/><path d="M12 9v6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' },
        { terms: ['fles', 'capaciteit', 'inhoud', 'liter', 'vulgewicht', 'couverts'], svg: '<svg viewBox="0 0 24 24" fill="none"><path d="M10 3h4v4l2 3v10H8V10l2-3V3Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>' },
        { terms: ['inbouw', 'vrijstaand', 'plaatsing', 'nis', 'nismaten', 'maatvoering'], svg: '<svg viewBox="0 0 24 24" fill="none"><rect x="6" y="3" width="12" height="18" rx="1.5" stroke="currentColor" stroke-width="1.6"/><path d="M15 12h.01" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>' },
        { terms: ['breedte', 'hoogte', 'diepte', 'afmetingen', 'meten', 'uitsparing'], svg: '<svg viewBox="0 0 24 24" fill="none"><path d="M5 7h14M5 17h14M7 5v4M17 5v4M7 15v4M17 15v4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' },
        { terms: ['geluid', 'trilling', 'stil', 'decibel'], svg: '<svg viewBox="0 0 24 24" fill="none"><path d="M4 10v4h4l5 4V6l-5 4H4Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M16 9a4 4 0 0 1 0 6M18.5 6.5a7.5 7.5 0 0 1 0 11" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' },
        { terms: ['ventilatie', 'lucht', 'afvoer', 'recirculatie'], svg: '<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="2" stroke="currentColor" stroke-width="1.5"/><path d="M12 10c-1-4 1-6 3-6 1.5 0 2.5 1 2.5 2.3C17.5 8 15 10 12 10ZM14 12c4-1 6 1 6 3 0 1.5-1 2.5-2.3 2.5C16 17.5 14 15 14 12ZM12 14c1 4-1 6-3 6-1.5 0-2.5-1-2.5-2.3C6.5 16 9 14 12 14ZM10 12c-4 1-6-1-6-3 0-1.5 1-2.5 2.3-2.5C8 6.5 10 9 10 12Z" stroke="currentColor" stroke-width="1.3"/></svg>' },
        { terms: ['energie', 'verbruik', 'zuinig', 'energielabel', 'kwh'], svg: '<svg viewBox="0 0 24 24" fill="none"><path d="M13 2 5 13h6l-1 9 9-12h-6V2Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>' },
        { terms: ['water', 'condens', 'reservoir', 'vocht', 'luchtvochtigheid'], svg: '<svg viewBox="0 0 24 24" fill="none"><path d="M12 3s5 5.5 5 10a5 5 0 1 1-10 0c0-4.5 5-10 5-10Z" stroke="currentColor" stroke-width="1.6"/></svg>' },
        { terms: ['programma', 'functie', 'instelling', 'bediening', 'automatisch'], svg: '<svg viewBox="0 0 24 24" fill="none"><rect x="4" y="5" width="16" height="14" rx="2" stroke="currentColor" stroke-width="1.6"/><path d="M8 9h8M8 13h5M8 17h3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' },
        { terms: ['onderhoud', 'reinigen', 'reiniging', 'filter', 'ontkalken', 'schoonmaak'], svg: '<svg viewBox="0 0 24 24" fill="none"><path d="m14 6 4 4M5 19l4.5-1 8-8a2.8 2.8 0 0 0-4-4l-8 8L5 19Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>' },
        { terms: ['veiligheid', 'kinderslot', 'slot', 'beveiliging'], svg: '<svg viewBox="0 0 24 24" fill="none"><rect x="5" y="10" width="14" height="10" rx="2" stroke="currentColor" stroke-width="1.6"/><path d="M8 10V7a4 4 0 0 1 8 0v3" stroke="currentColor" stroke-width="1.6"/></svg>' },
        { terms: ['deur', 'draairichting', 'scharnier', 'front'], svg: '<svg viewBox="0 0 24 24" fill="none"><path d="M6 3h11v18H6V3Z" stroke="currentColor" stroke-width="1.6"/><path d="M14 12h.01" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>' },
        { terms: ['stoom', 'damp', 'regenereren'], svg: '<svg viewBox="0 0 24 24" fill="none"><path d="M8 18c-2-2 2-3 0-5s2-3 0-5M13 18c-2-2 2-3 0-5s2-3 0-5M18 18c-2-2 2-3 0-5s2-3 0-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' },
        { terms: ['no frost', 'low frost', 'ijs', 'ontdooien', 'vriezen'], svg: '<svg viewBox="0 0 24 24" fill="none"><path d="M12 3v18M4.2 7.5l15.6 9M4.2 16.5l15.6-9M8 5l4 2 4-2M8 19l4-2 4 2" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>' },
        { terms: ['aansluiting', 'perilex', 'fase', 'elektrisch', 'vermogen', 'stekker'], svg: '<svg viewBox="0 0 24 24" fill="none"><path d="M8 3v6M16 3v6M6 9h12v2a6 6 0 0 1-12 0V9Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><path d="M12 17v4" stroke="currentColor" stroke-width="1.6"/></svg>' },
        { terms: ['koffie', 'espresso', 'bonen', 'molen', 'melk'], svg: '<svg viewBox="0 0 24 24" fill="none"><path d="M5 8h11v7a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4V8Z" stroke="currentColor" stroke-width="1.6"/><path d="M16 10h2a2 2 0 0 1 0 4h-2M8 4c0 1 1 1 1 2M12 4c0 1 1 1 1 2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' },
        { terms: ['checklist', 'controle', 'samenvatting'], svg: '<svg viewBox="0 0 24 24" fill="none"><path d="m5 7 2 2 4-4M5 13l2 2 4-4M14 7h5M14 13h5M5 19h14" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>' },
        { terms: ['veelgestelde', 'vragen', 'faq'], svg: '<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/><path d="M9.8 9.2a2.5 2.5 0 0 1 4.8.9c0 1.8-2.6 2.1-2.6 3.9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><circle cx="12" cy="17.2" r=".9" fill="currentColor"/></svg>' },
        { terms: ['advies', 'ons advies', 'kiezen', 'keuze'], svg: '<svg viewBox="0 0 24 24" fill="none"><path d="M9 18h6M10 21h4M8 14c-1.4-1.1-2-2.6-2-4a6 6 0 1 1 12 0c0 1.4-.6 2.9-2 4-1 .8-1 1.3-1 2H9c0-.7 0-1.2-1-2Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' },
        { terms: ['zakelijk', 'project', 'gemeente', 'verhuur', 'studenten', 'opvang'], svg: '<svg viewBox="0 0 24 24" fill="none"><path d="M4 20V8h6V4h4v4h6v12H4Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M8 12h2M14 12h2M8 16h2M14 16h2" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>' },
        { terms: ['logistiek', 'levering', 'bezorging', 'transport', 'retourname'], svg: '<svg viewBox="0 0 24 24" fill="none"><path d="M3 6h11v11H3V6ZM14 10h4l3 3v4h-7v-7Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="7" cy="18" r="2" stroke="currentColor" stroke-width="1.6"/><circle cx="18" cy="18" r="2" stroke="currentColor" stroke-width="1.6"/></svg>' },
        { terms: ['service', 'garantie', 'reparatie', 'vervanging'], svg: '<svg viewBox="0 0 24 24" fill="none"><path d="M14.5 5.5a4 4 0 0 0-5 5L4 16l4 4 5.5-5.5a4 4 0 0 0 5-5l-3 3-3-3 3-3Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>' },
        { terms: ['bewaren', 'serveren', 'gebruik', 'doel'], svg: '<svg viewBox="0 0 24 24" fill="none"><path d="M5 5h14M5 12h14M5 19h14" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><circle cx="8" cy="5" r="1.4" fill="currentColor"/><circle cx="8" cy="12" r="1.4" fill="currentColor"/><circle cx="8" cy="19" r="1.4" fill="currentColor"/></svg>' }
      ];

      const selectedIcon = iconMap.find(({ terms }) =>
        terms.some((term) => normalised.includes(term))
      );

      const fallbackIcon = '<svg viewBox="0 0 24 24" fill="none"><path d="M6 7h12M6 12h12M6 17h12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

      const link = document.createElement('a');
      link.className = 'pw-guide-article__toc-link';
      link.href = `#${heading.id}`;

      const icon = document.createElement('span');
      icon.className = 'pw-guide-article__toc-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = selectedIcon?.svg || fallbackIcon;

      const text = document.createElement('span');
      text.textContent = title;

      link.append(icon, text);
      item.appendChild(link);
      tocList.appendChild(item);

      return { heading, link };
    });

    toc.hidden = false;

    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

        if (!visible.length) return;

        links.forEach(({ link }) => link.classList.remove('is-active'));

        const active = links.find(({ heading }) => heading === visible[0].target);
        active?.link.classList.add('is-active');
      },
      {
        rootMargin: '-15% 0px -70% 0px',
        threshold: 0
      }
    );

    headings.forEach((heading) => observer.observe(heading));
  };

  const initialiseAll = (scope = document) => {
    scope.querySelectorAll('.js-pw-guide-article').forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
